export default __webpack_public_path__ + "static/media/BlackCastleValley.99e119ac.jpg";